import { render, staticRenderFns } from "./AddEditAddress.vue?vue&type=template&id=50e2918e&scoped=true"
import script from "./AddEditAddress.vue?vue&type=script&lang=js"
export * from "./AddEditAddress.vue?vue&type=script&lang=js"
import style0 from "./AddEditAddress.vue?vue&type=style&index=0&id=50e2918e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e2918e",
  null
  
)

export default component.exports